import { redirect } from '@tanstack/react-router';
import { getThirdPartyData } from '../api/third-parties/get-third-party-data';
import {
  isNotFoundError, isGoneError, NotFoundErrorCode, ApiError,
} from './errors';
import { SurveySettings } from '../types';

export type ThirdPartyLoaderResponse =
  | { type: 'success'; settings: SurveySettings }
  | { type: 'error'; error: ApiError };

interface ThirdPartyLoaderParams {
  accountSlug: string;
  trackingId: string;
}

export const thirdPartyLoader = async ({
  accountSlug,
  trackingId,
}: ThirdPartyLoaderParams): Promise<ThirdPartyLoaderResponse> => {
  try {
    const { settings } = await getThirdPartyData(accountSlug, trackingId);

    return {
      type: 'success',
      settings,
    };
  } catch (error) {
    if (isNotFoundError(error) && error.code === NotFoundErrorCode.SettingsNotFound) {
      throw redirect({ to: '/' });
    }

    if ((isNotFoundError(error) && error.code === NotFoundErrorCode.ThirdPartyNotFound) ||
      isGoneError(error)) {
      return {
        type: 'error',
        error,
      };
    }

    throw error;
  }
};
